export default __webpack_public_path__ + "static/media/medical.7be0db51.png";